// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3jHBv","cell":"ColumnAccessor_cell__1mH97","firstCellAccent":"ColumnAccessor_firstCellAccent__16Zs3"};